var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mq-tab"},[(_vm.$slots.default)?_vm._t("default"):_c('div',{staticClass:"wrapper"},[(_vm.icon)?_c('svg-icon',{attrs:{"size":_vm.iconHeight,"fill":_vm.color,"name":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text hide-for-small-only"},[_vm._v(_vm._s(_vm.title))])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af759514","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MqTab.vue
// module id = null
// module chunks = 